import { endpoints } from "./endpoints";
import { EnvironmentModel, MXURLS } from "./environment.modal";

export const MX: MXURLS = {
  notificationServiceBaseURL:
    "https://mx-notify-prod-gateway.manifestmedex.org",
};
export const environment: EnvironmentModel = {
  production: false,
  endPoints: endpoints,
};
